import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise} from "angular";

require('./aktiverEidDialog.scss');

export class AktiverEidDialogKontroller {

    static visAktiverEidDialog($mdDialog: angular.material.IDialogService):IPromise<void>{
        return $mdDialog.show({
            template: require('./aktiverEidDialog.html'),
            controller:  [regNavn.md.$mdDialog, AktiverEidDialogKontroller],
            controllerAs: '$ctrl',
            bindToController: true
        });
    }

    static forInjisering() {
        return [regNavn.md.$mdDialog, AktiverEidDialogKontroller]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    lukk() {
        this.$mdDialog.hide();
    }
}
